import React from 'react';
import {Col, Container, Row, Card, CardBody, Button} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {fetchDeletedDealsDataIfNeeded} from '../../redux/actions/DeletedDealsActions';
import {fetchUtilsDataIfNeeded} from '../../redux/actions/UtilsActions'
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import * as TextManager from "../../modules/languages/TextManager";
import DateSelector from '../../components/DateSelector'
import DeletedDealsTable from "./components/DeletedDealsTable";


export class DeletedDeals extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: ''
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchDeletedDealsDataIfNeeded(this.queryParams));

        this.props.dispatch(fetchUtilsDataIfNeeded());
    }

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if(typeof mr === 'number' ) {
                    if(mr.toString(16).toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    render() {
        let data = this.props.data;

        if (this.state.searchValue !== '') {
            data = this.props.data.filter(this.filterDataBySearch)
        }

        return (
            <Container className='dashboard'>
                { this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                { this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                { this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'success' &&
                <span>
                    <Row>
                      <Col md={3} md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3 style={{textAlign: 'right'}}>עסקאות שנמחקו</h3>
                                <div style={{display: 'flex', height: '100%', width: '70%'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                      <DateSelector endpoint='deleted_deals'/>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>

                            <CardBody style={{padding: "1.25rem"}}>
                                <div style={{display: 'flex', height: '100%', justifyContent: 'flex-end'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                      <form className='topbar__search material-form'>
                                        <div
                                            className='search_field_form_control material-form__field topbar__search-field'>
                                            <div className='search_field_root search_field_custom-underline'
                                                 style={{border: 'groove'}}>
                                                <input className='search_field_custom-input' dir="rtl"
                                                       placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                                       value={this.state.searchValue}
                                                       onChange={(e) => this.changeSearch(e)}/>
                                            </div>
                                        </div>
                                      </form>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>

                    {/*<input type="file" accept="image/*" id="file-input" />
                    <script>
                      const fileInput = document.getElementById('file-input');

                      fileInput.addEventListener('change', (e) =>
                        doSomethingWithFiles(e.target.files),
                      );
                    </script>*/}
                    <Row>
                        <DeletedDealsTable data={data}/>
                    </Row>
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.deletedDeals.status,
        data: state.deletedDeals.data,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(DeletedDeals))